import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  glow?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
  padding = 'md',
  hover = false,
  glow = false,
}) => {
  const paddings = {
    none: '',
    sm:   'p-3',
    md:   'p-5',
    lg:   'p-6',
  };

  const base = 'bg-white rounded-2xl border border-slate-200 shadow-card';

  const hoverCls = hover
    ? 'transition-all duration-300 hover:shadow-card-hover hover:-translate-y-0.5 hover:border-slate-300 cursor-pointer'
    : '';

  const glowCls = glow ? 'hover:shadow-glow-sm hover:border-primary-100' : '';

  return (
    <div
      className={`${base} ${paddings[padding]} ${hoverCls} ${glowCls} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;
